<div>
    <div class="dialog-icon-wrapper">
        <img src="./assets/images/icons/dialog-warning.svg" />
    </div>
    <div class="title">
        <h2>{{title}}</h2>
    </div>
    <div class="content-area">
        <p class="message" [innerHtml]="message"></p>
    </div>
    <div class="dialog-actions">
        <button type="button" class="btn-link button-cancel" clickable (click)="cancel()"><span>{{ cancelLabel }}</span></button>
        <button type="button" class="button-common button40 active button-ok" clickable (click)="ok()"><span>{{okLabel}}</span></button>
    </div>
</div>